<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <el-select v-model='formDatas.projectId' v-if="theUserProject == 0" clearable size="small"
                @change="theSelectProjectChange" placeholder="请选择项目">
                <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                    :label="item.projectName" :value="item.projectId">
                </el-option>
            </el-select>
            <el-col :span="4">
                <el-cascader ref='cascader' v-model="formDatas.dtId" clearable filterable size='small'
                    placeholder='请选择战队' :show-all-levels='false'
                    :options="getDepartmentAllList_data ? getDepartmentAllList_data.data : []"
                    :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'dtName', value: 'dtId', children: 'children' }"
                    @change="$refs.cascader.dropDownVisible = false, getProjectUserAll({ postId: 5, dtId: formDatas.dtId, projectId: formDatas.projectId }), getTableList()">
                    <template slot-scope="{ data }">
                        <span onclick="this.parentNode.previousElementSibling.click()">{{ data.dtName }}</span>
                    </template>
                </el-cascader>
            </el-col>
            <el-col :span="4" v-if="formDatas.dtId">
                <el-select v-model="formDatas.userId" @change="getTableList" size="small" filterable clearable
                    placeholder="请选择学员">
                    <el-option v-for="item in getProjectUserAll_data.data || []" :key="item.userId"
                        :label="item.userName" :value="item.userId">
                    </el-option>
                </el-select>
            </el-col>
            <!-- <el-button @click="toExportExcelWg" type="primary" icon='el-icon-search' size='small'
                style='margin-left:10px;'>导出区域数据
            </el-button> -->
            <el-date-picker v-model="valueDate" size='small' type="daterange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
                value-format="yyyy-MM-dd" align="right">
            </el-date-picker>
            <el-button @click="toExportExcelSts" type="primary" icon='el-icon-search' size='small'
                style='margin-left:10px;'>导出
            </el-button>
        </el-row>
        <!-- <mytable ref="mytable" 
            :tableColums='tableColums_getStatisticsOpportunityDetails' api='getStatisticsOpportunityDetails::dtId' xupdateapi='updateUserTarget'
            :height="H - 165" >
        </mytable> -->
        <el-table :data="tableData" height="640" border style="width: 100%">
            <el-table-column v-for="(item, index) in tableHand || []" :key="index" :prop="'row' + index" :label="item"
                :width="index == 0 ? '180' : ''" :fixed="index == 0 ? 'left' : ''">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            formDatas: {
                projectId: '',
                dtId: '',
                userId: '',
                startDate: '',
                endDate: '',
            },
            tableHand: [],//表头
            tableData: [],//表格数据
            loading: "",
            theProjectId: "",
            theSelectProjectId: "",
            tableColums_getStatisticsOpportunityDetails: {
                $selection: false,
                dtName: ['战队|align:left', 400],
                // dtOrderNum: '订单数',
                // dtPoints: '积分',
                // dtVisitorNum: '拜访量',
                // dtYj: '业绩',
                // dtBusinessNum: '数量',
            },
            baseUrl: $Api.baseUrl_online,
            valueDate: "",
            startDate: "",
            endDate: "",
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        timeChange(e) {
            if (e) {
                this.formDatas.startDate = e[0];
                this.formDatas.endDate = e[1];
            } else {
                this.formDatas.startDate = "";
                this.formDatas.endDate = "";
            }
            this.getTableList();
        },
        toExportExcelWg: async function () {
            const that = this;
            that.openLoading();
            axios({
                method: 'post',
                url: that.baseUrl + '/opportunity/user/exportProjectAnalysisWg',
                data: {},
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                }
            }).then(function (response) {
                that.loading.close();
                let a = document.createElement('a');
                //ArrayBuffer 转为 Blob
                let blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
                let objectUrl = URL.createObjectURL(blob);
                a.setAttribute("href", objectUrl);
                a.setAttribute("download", '区域.xlsx');
                a.click();
                that.$message({
                    message: "成功",
                    type: "success"
                });
            }).catch(function (error) {
                that.loading.close();
                console.log(error);
            });
        },
        toExportExcelSts: async function () {
            const that = this;
            // var postData = {
            //     startDate: that.startDate,
            //     endDate: that.endDate
            // };
            var s = qs.stringify(that.formDatas);
            that.openLoading();
            axios({
                method: 'post',
                url: that.baseUrl + '/opportunity/ou-statistics/exportStatisticsOpportunityDetails',
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                }
            }).then(function (response) {
                that.loading.close();
                let a = document.createElement('a');
                //ArrayBuffer 转为 Blob
                let blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
                let objectUrl = URL.createObjectURL(blob);
                a.setAttribute("href", objectUrl);
                a.setAttribute("download", '项目业务分析.xlsx');
                a.click();
                that.$message({
                    message: "成功",
                    type: "success"
                });
            }).catch(function (error) {
                that.loading.close();
                console.log(error);
            });
        },
        theSelectProjectChange(e) {
            //搜索
            this.getStatisticsOpportunityDetails(this.formDatas);
            this.getDepartmentAllList({ projectId: e });
        },
        expand(row, expanded) {
            // return console.warn(row,expanded);
            if (row.dtLevel == 1 || row.hasChildren2 === false) return;
            const treeData = this.$refs.mytable.Table.store.states.treeData, children = (treeData[row._parent] || 0).children || '';
            if (children.length < 2) return;
            // console.error(row, expanded, row._parent, children, row.hasChildren);
            for (let id of children) {
                if (id !== row.dtId) treeData[id] && (treeData[id].expanded = false);
            };
            return;
        },
        lazyLoad(treeData, treeNode, resolve) {
            // console.warn(treeData);
            if (treeData.dtLevel > 1) {

            };
            axios({
                method: 'post',
                baseURL: $Api.baseUrl_online, //线上
                url: (Apis.getStatisticsOpportunityDetails || 0)[0] || '/opportunity/user/getStatisticsOpportunityDetails',
                withCredentials: true,
                data: qs.stringify({ dtId: treeData.dtId, projectId: this.getStatisticsOpportunityDetails_data.projectId }),
                timeout: 900000,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                    // "Set-Cookie": `httpOnly; Secure; SameSite = None`,
                    // res.setHeader('Set-Cookie',`name={"loginname":"${userName}"}; httpOnly; Secure; SameSite = None`);
                }
            }).then(res => {
                let now;
                res = res.data.data || [];
                // console.error(res, treeData._rowIndex);
                if (res.length !== 0) return treeData.hasChildren2 = true, resolve(
                    treeData.dtLevel != 4
                        ? forArr(res, v => (v.hasChildren = true, v._parent = treeData.dtId))
                        : forArr(res, v => (v.dtId = now + res++, v._parent = treeData.dtId, v.dtName = v.userName || v.dtName), res = 1, now = Date.now())
                );
                treeData.hasChildren2 = false, resolve([]);
            }).catch(err => {
                resolve([]);
            });

        },
        getTableList() {
            this.getStatisticsOpportunityDetails(this.formDatas).result(res => {
                this.tableData = [];
                this.tableHand = res.data.data[0];
                res.data.data.forEach((item, index) => {
                    if (index > 0) {
                        const s = {}
                        item.forEach((rowKey, rowIndex) => {
                            s['row' + rowIndex] = rowKey
                            if (rowIndex >= item.length - 1) {
                                this.tableData.push(s)
                                console.log(this.tableData);
                            }
                        })

                    }
                })


            })
        },
    },
    created() {
        this.getProjectList({ pageSize: 0 });
        this.getDepartmentAllList();
        this.theUserProject = A.local('$projectId');
        this.formDatas.projectId = A.local('$projectId');
        if (this.theUserProject != 0) {
            this.theProjectId = this.theUserProject;

        }
        this.getTableList();
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/data/BusinessStatistics.vue